import { getField, updateField } from 'vuex-map-fields'
import api from '@/api/api'
import { Setor } from '@/models/Setor'
import Swal from 'sweetalert2'
import { setorTransformer } from '@/utils/transformers'

export const SET_STATE = 'SET_STATE'
export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const SUBMIT = 'SUBMIT'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    setores: [],
    loading: true,
    isEditing: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { id }) {
    commit(RESET_STATE)
    commit(SET_STATE, { loading: true, isEditing: false })
    dispatch('form/BOOTSTRAP_FORM', { model: new Setor() }, { root: true })
    if (id) {
      commit(SET_STATE, { isEditing: true })
      await api.getEntidade('setor', id).then(response => {
        // Array.isArray(response.data) ? response.data[0] : response.data
        const setorData = response.data[0]
        dispatch('form/BOOTSTRAP_FORM', { model: new Setor(setorTransformer(setorData)) }, { root: true })
      })
    }
    commit(SET_STATE, { loading: false })
  },
  async [SUBMIT] ({ dispatch, commit, state, rootState }, { id, router, user }) {
    Swal.fire({
      title: 'Enviando dados!',
      timerProgressBar: true,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
      didOpen: () => {
        const form = { ...rootState.form.data };
        (() => {
          return state.isEditing
            ? api.salvarEntidade(form, 'setor', form.id)
            : api.cadastrarEntidade(form, 'setor')
        })().then(
          data => {
            Swal.fire({
              title: state.isEditing
                ? 'Setor atualizado com sucesso!'
                : 'Setor cadastrado com sucesso!',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            })
            router.push({
              path: `/${user.get().role}/setores`,
            })
          },
          error => {
            Swal.fire({
              icon: 'error',
              title: 'Atenção',
              text: error.message,
            })
          },
        )
      },
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
